/**
 * 基于拼音的智能唤醒词检测器
 */

import { pinyin } from 'pinyin-pro';

// 默认唤醒词配置
export const DEFAULT_WAKE_WORDS = [
  '你好',
  '同学',
  '小派',
  '开始',
  '您好',
  '金融',
  '健康',
  '数字',
  '反诈',
];

/**
 * 获取汉字的拼音（无音调）
 */
function getPinyinWithoutTone(text: string): string {
  try {
    return pinyin(text, { toneType: 'none', type: 'array' }).join('').toLowerCase();
  } catch {
    return text.toLowerCase();
  }
}

/**
 * 检测文本中是否包含唤醒词
 */
export function detectWakeWord(
  text: string,
  wakeWords: string[] = DEFAULT_WAKE_WORDS,
  enableHomophone: boolean = true
): boolean {
  if (!text?.trim()) {
    return false;
  }

  const cleanText = text.trim();

  // 精确匹配
  if (wakeWords.some((word) => cleanText.includes(word))) {
    return true;
  }

  // 拼音匹配
  if (enableHomophone) {
    const inputPinyin = getPinyinWithoutTone(cleanText);
    const targetSegments = wakeWords.map((word) => getPinyinWithoutTone(word));

    return targetSegments.some((segment) => inputPinyin.includes(segment));
  }

  return false;
}

/**
 * 获取匹配的唤醒词信息
 */
export function getMatchedWakeWords(
  text: string,
  wakeWords: string[] = DEFAULT_WAKE_WORDS,
  enableHomophone: boolean = true
): string[] {
  if (!text?.trim()) {
    return [];
  }

  const cleanText = text.trim();
  const matches: string[] = [];

  // 精确匹配
  wakeWords.forEach((word) => {
    if (cleanText.includes(word)) {
      matches.push(word);
    }
  });

  // 拼音匹配
  if (enableHomophone && matches.length === 0) {
    const inputPinyin = getPinyinWithoutTone(cleanText);
    wakeWords.forEach((word) => {
      const wordPinyin = getPinyinWithoutTone(word);
      if (inputPinyin.includes(wordPinyin)) {
        matches.push(word);
      }
    });
  }

  return matches;
}

// 导出类型
export interface WakeWordDetectorConfig {
  wakeWords: string[];
  enableHomophone: boolean;
}
